/**
* ユーザー管理関連
*/

import axios from '@/plugins/axios';
import cf from '@/mixins/commonFunctions';
import login from './login';
import cards from './cards';
import subscriptions from './subscriptions';

const actions = {
  setUserData({ commit }, data) {
    commit('setUserData', data);
  },


  /** DBからユーザー情報を取得しstate更新 */
  update({ commit, dispatch, state }) {
    const ls = cf.getLocalStorage('fk');
    // localStorageが存在しない場合はスルー
    if (!ls) return;

    if (state.login.isLogin && ls.jwt) {
      // ログインしていてjwtを所持している場合
      const Authorization = `${ls.jwt.type} ${ls.jwt.token}`;
      axios({
        method: 'GET',
        url: '/v1/user/get/authUser',
        headers: { Authorization },
      })
        .then((response) => {
          const user = response.data.user;
          commit('update', user);
          // ユーザーの支払い方法データ
          if (user.customer) {
            dispatch('user/cards/getCustomer', user, { root: true });
            dispatch('user/subscriptions/getSubscriptions', user, { root: true });
          }
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
        });
    } else if (ls.supportType === 'guest' && ls.user_id) {
      // ゲストユーザ
      axios({
        method: 'GET',
        url: '/v1/user/get/byId',
        params: {
          id: ls.user_id,
        },
      })
        .then((response) => {
          const user = response.data.user;
          commit('setUserData', user);
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
        });
    }
  },
};

const mutations = {
  setUserData(state, data) {
    const keys = Object.keys(data);
    keys.some((key) => {
      // passwordはstoreで保持しない
      if (key !== 'password') {
        state[key] = data[key];
      }
      return false;
    });
  },

  update(state, user) {
    const userKeys = Object.keys(user);
    const stateKeys = Object.keys(state);
    // 取得したuserの値をまわして
    userKeys.some((key) => {
      // キーが存在するstateを更新
      if (stateKeys.includes(key)) {
        // console.log(key);
        state[key] = user[key];
      }
      return false;
    });
  },
};

const state = {
  id: '',
  username: '',
};


export default {
  namespaced: true,
  actions,
  mutations,
  state,
  modules: {
    login,
    cards,
    subscriptions,
  },
};
